import axios from "axios";
import { redirectToLoginIfSessionExpired } from "@/src/shared/utils/sessionExpiryRedirect";

window.addEventListener(
  "beforeunload",
  e => {
    if (window.__easyRedirectingToLogin) {
      delete e.returnValue;
      e.stopImmediatePropagation();
    }
  },
  { capture: true }
);

axios.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status) {
      redirectToLoginIfSessionExpired(error.response.status);
    }
    return Promise.reject(error);
  }
);
